import PledgesScreen from './PledgesScreen';

export default PledgesScreen;
